export const OFFER_INSURANCE_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.InsuranceSaved";

export const OFFER_INSURANCE_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.OfferInsurancesInvalidated";
